import React from 'react'
import {useStyles} from "./DifficultyIndication.css";
import {useIntl} from "react-intl";
import generalConfig from "../../../commons/associationStructure/generalConfig.json";

const DifficultyIndication = ({difficulty}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    if (!generalConfig.difficulty.includes(difficulty)) {
        return difficulty || ''
    }

    return <div className={classes[difficulty]}>
        {intl.formatMessage({
            id: `app.ids.difficulty.${difficulty}`,
            defaultMessage: difficulty
        })}
    </div>
}
export default DifficultyIndication
